document.addEventListener('DOMContentLoaded', function() {
    const $imageGalleries = document.querySelectorAll('.image-gallery');

    if($imageGalleries) {
        $imageGalleries.forEach($imageGallery => {
            const $imagePreview = $imageGallery.querySelector('.image-gallery__preview > img');
            const $imageThumbnails = $imageGallery.querySelectorAll('.image-gallery__thumbnail');

            $imageThumbnails.forEach($imageThumb => {
                $imageThumb.addEventListener('click', function(e) {
                    e.preventDefault();

                    const $thumb = $imageThumb.querySelector('img');

                    $imageThumbnails.forEach($iT => {
                        $iT.classList.remove('active');
                    });

                    $imageThumb.classList.add('active');

                    const $src = $thumb.src;

                    $imagePreview.src = $src;
                });
            });
        });
    }
});